'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dUser$002dName$0024 from "./presto.types$-User-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialTables$$anon$19() {
}
export { $c_Lpresto_CredentialTables$$anon$19 as $c_Lpresto_CredentialTables$$anon$19 };
$p = $c_Lpresto_CredentialTables$$anon$19.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialTables$$anon$19;
/** @constructor */
function $h_Lpresto_CredentialTables$$anon$19() {
}
export { $h_Lpresto_CredentialTables$$anon$19 as $h_Lpresto_CredentialTables$$anon$19 };
$h_Lpresto_CredentialTables$$anon$19.prototype = $p;
$p.b6 = (function(_$65) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(_$65, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$66) => _$66.iw.tP.Ds)), $j_presto$002etypes$0024$002dUser$002dName$0024.$m_Lpresto_types$UserName$().cI6());
});
var $d_Lpresto_CredentialTables$$anon$19 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialTables$$anon$19, "presto.CredentialTables$$anon$19", ({
  FD: 1,
  G: 1
}));
export { $d_Lpresto_CredentialTables$$anon$19 as $d_Lpresto_CredentialTables$$anon$19 };
//# sourceMappingURL=presto.-Credential-Tables$$anon$19.js.map
